<svg width="24" height="24" fill="none" stroke="black" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <path d="m12 8v8m4-4h-8m4 10c5.5228 0 10-4.4772 10-10 0-5.5228-4.4772-10-10-10-5.5228 0-10 4.4772-10 10 0 5.5228 4.4772 10 10 10z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
</svg>
